module.exports = __webpack_public_path__ + "nucleo-outline.24e2d6b43b1b0f84fdfa.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/assets/fonts/nucleo-outline.woff
// module id = ../../../../../src/assets/fonts/nucleo-outline.woff
// module chunks = 17